import {image, glyphs} from '../settings';
import _ from 'lodash';
import { getProjectSlug } from './slugify';

const createItems = (items, singleProjects) => {
  let galleryItems = [];

    items.forEach(item => {
      if(item.slice_type === "project"){
        galleryItems.push(createProjectItem(item,singleProjects));
      }
      else if(item.slice_type === "letter") {
        galleryItems.push(createGlyphItem(item));
      }
      else {
        galleryItems.push(createImageItem(item));
      }
    });

  return galleryItems;
}

const createImageItem = (item, size) => {
  let format = item['slice_type'];
  if(item.primary.size){
    size = item.primary.size;
  }
  return {
    type: "image",
    format: format,
    ratio: image.ratio[format],
    width: image.width[format][size],
    dimension: {width: null, height: null},
    alt: item.primary.image.alt,
    url: item.primary.image.url,
    retina: item.primary.image.retina.url
  }
}

const createGlyphItem = item => {
  return {
    type: "glyph",
    glyph: item.primary.letter,
    ratio: [1,1],
    width: glyphs.width,
    dimension: {width: null, height: null}
  }
}

const createProjectItem = (item, singleProjects) => {
  let {id} = item.primary.link;
  let project = _.find(singleProjects, { id });
  let size = project.data.size;
  let images = project.data.body.map(image => createImageItem(image, size));
  let {format} = images[0];

  let open = {
    width: image.width[format]['open'],
    ratio: image.ratio[format]
  }

  // if images have different formats -> open format is sqaure
  images.forEach(img => {
    if(images[0].format !== img.format) {
      open.width = image.width['square']['open'];
      open.ratio = image.ratio['square'];
    }
  });

  return {
    type: "project",
    id: id,
    slug: getProjectSlug(project),
    index: 0,
    images: images,
    isOpen: false,
    open: open,
    dimension: {width: null, height: null},
    text: project.data.text,
    title: project.data.title
  }
}

export default createItems;




// WEBPACK FOOTER //
// ./src/utils/createItems.js